/* eslint-disable  @typescript-eslint/no-explicit-any */
export enum LayoutAction {
  LAYOUT_LOAD_JSON = "LAYOUT_LOAD_JSON",
  LAYOUT_LOAD_JSON_SET = "LAYOUT_LOAD_JSON_SET"
}
const initialState: any = {};

/**
 **Layout reducer from dynamic page creation
 * Not required for static defined projects
 */

const layoutReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case LayoutAction.LAYOUT_LOAD_JSON:
      return state;
    case LayoutAction.LAYOUT_LOAD_JSON_SET:
      if (action.payload.data != null) {
        state[action.payload.fri] = action.payload.data;
      }
      return state;
    default:
      return state;
  }
};

export default layoutReducer;
